import cover from "assets/images/ugc_v1/welcome-cover.webp"
import { Button } from "../paygate-2screen/button"
import { FormattedMessage } from "react-intl"
import { Screen } from "config/types"

interface Props {
  screen: Screen
  isActive: boolean
  onClick: () => void
}

export function UGCWelcomeScreen(props: Props) {
  const { customProperties = {} } = props.screen

  return (
    <div className="h-[calc(100dvh-32px)] flex flex-col pt-10 height-770:pt-4">
      <h1 className="font-quirk text-[36px] leading-[44px] text-center mb-2 max-w-[270px] mx-auto shrink-0 height-600:text-[28px] height-600:leading-[36px] height-600:max-w-[300px]">
        <FormattedMessage id="ugc_v1.welcome.title" />
      </h1>

      <div className="flex-1 min-h-0 flex items-center justify-center mb-4">
        <img
          src={cover}
          alt=""
          className="w-full h-full object-contain max-w-[300px]"
        />
      </div>

      <p className="text-center text-2xl mb-12 height-770:mb-8 shrink-0">
        <FormattedMessage id="ugc_v1.welcome.description" />
      </p>

      <div className="shrink-0">
        <Button theme="black" onClick={props.onClick}>
          Continue
        </Button>
      </div>

      <div className="mt-4 text-center text-base text-gray-300 shrink-0 pb-6 height-700:pb-2">
        <FormattedMessage
          id={customProperties.legalText as string}
          values={{
            terms: (chunks) => (
              <a
                href="https://pure.app/content/en/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="italic font-serif-italic text-sm"
              >
                {chunks}
              </a>
            ),
            privacy: (chunks) => (
              <a
                href="https://pure.app/content/en/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="italic font-serif-italic text-sm"
              >
                {chunks}
              </a>
            ),
            safety: (chunks) => (
              <a
                href="https://pure.app/content/en/security"
                target="_blank"
                rel="noopener noreferrer"
                className="italic font-serif-italic text-sm"
              >
                {chunks}
              </a>
            ),
            guidelines: (chunks) => (
              <a
                href="https://pure.app/content/en/guidelines"
                target="_blank"
                rel="noopener noreferrer"
                className="italic font-serif-italic text-sm"
              >
                {chunks}
              </a>
            ),
          }}
        />
      </div>
    </div>
  )
}
